export const formatPrice = (price=0) => {
	if (typeof price === 'string') {
		price = Number(price);
	}
	let formattedPrice = price.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});

	return formattedPrice;
}

export const calculateVATByPrice = ( price ) => {
    const vat = price * 0.12;
    return vat
}

export const calculateTCP = (price, vat ) => {
    const tcp = price + vat;
    return tcp
}